export const categories = [
  { slug: 'zuixin-zixun', name: '最新资讯', icon: 'ri-flashlight-line', description: '掌握麻豆在线平台最新动态与行业资讯' },
  { slug: 'yingshi-tuijian', name: '影视推荐', icon: 'ri-movie-2-line', description: '精选高清正版影视内容，每周更新推荐' },
  { slug: 'remen-paihang', name: '热门排行', icon: 'ri-fire-line', description: '最受用户欢迎的内容排行榜单' },
  { slug: 'huiyuan-zhuanxiang', name: '会员专享', icon: 'ri-vip-crown-line', description: '麻豆在线会员专属优质内容' },
  { slug: 'hangye-dongtai', name: '行业动态', icon: 'ri-global-line', description: '影视行业前沿趋势与深度分析' },
  { slug: 'guanfang-gonggao', name: '官方公告', icon: 'ri-megaphone-line', description: '麻豆在线平台官方通知与活动公告' },
];

export const articles = [
  {
    id: 1,
    slug: 'madou-zaixian-2026-xiaji-xinpian',
    title: '麻豆在线2026夏季新片重磅上线，百部正版高清大片等你来看',
    excerpt: '麻豆在线2026年夏季内容矩阵全面升级，涵盖动作、喜剧、悬疑、纪录片等多种类型，全部正版授权，高清画质带来沉浸式观影体验。',
    content: `<p>随着2026年夏季的到来，<strong>麻豆在线</strong>平台迎来新一轮内容大更新。本次夏季档期共上线超过百部正版高清影视作品，涵盖动作大片、温馨喜剧、烧脑悬疑、精品纪录片等多元类型，满足不同用户的观影需求。</p>
<p>作为国内领先的正版内容平台，<strong>麻豆在线</strong>始终坚持以用户体验为核心，持续引进优质版权内容。本次夏季片单中，多部国际获奖影片首次登陆平台，为用户带来世界级的视听盛宴。</p>
<h2>夏季新片亮点</h2>
<p>动作类新片阵容豪华，多部高口碑作品同步上线。喜剧类作品则聚焦生活百态，轻松幽默又不失深度。悬疑类作品剧情紧凑、反转不断，是推理爱好者的必看之选。纪录片板块新增自然探索与人文历史两大系列，画面精美、知识性强。</p>
<p><strong>麻豆在线高清</strong>技术全面升级，所有新片均支持4K超清画质与杜比全景声，配合智能流畅播放技术，确保用户在任何网络环境下都能享受极致观影体验。</p>
<h2>会员专享权益</h2>
<p><strong>麻豆在线会员</strong>可抢先观看全部夏季新片，尊享无广告纯净观影模式，同时支持多设备同步观看记录，随时随地畅享精彩内容。</p>`,
    category: 'zuixin-zixun',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20home%20cinema%20setup%20with%20large%20screen%20displaying%20colorful%20movie%20posters%2C%20warm%20ambient%20lighting%2C%20cozy%20living%20room%20atmosphere%2C%20soft%20neutral%20background%20with%20natural%20textures%2C%20cinematic%20mood%2C%20clean%20composition&width=800&height=500&seq=article-summer-2026&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20home%20cinema%20setup%20with%20large%20screen%20displaying%20colorful%20movie%20posters%2C%20warm%20ambient%20lighting%2C%20cozy%20living%20room%20atmosphere%2C%20soft%20neutral%20background%20with%20natural%20textures%2C%20cinematic%20mood%2C%20clean%20composition&width=300&height=300&seq=article-summer-2026-thumb&orientation=squarish',
    author: '麻豆在线编辑部',
    date: '2026-08-05',
    readTime: '8分钟',
    tags: ['麻豆在线', '夏季新片', '高清影视', '正版内容'],
    featured: true,
  },
  {
    id: 2,
    slug: 'huiyuan-tixi-quanmian-shengji',
    title: '麻豆在线会员体系全面升级，更多权益等你解锁',
    excerpt: '麻豆在线宣布会员体系重大升级，新增多项专属权益，包括独家内容、优先观影、线下活动等，让每一位会员享受超值服务。',
    content: `<p><strong>麻豆在线</strong>正式宣布会员体系全面升级，此次升级覆盖权益范围、内容深度与服务品质三大维度，旨在为用户提供更加丰富多元的会员体验。</p>
<p>作为平台发展的重要里程碑，<strong>麻豆在线会员</strong>体系此次升级新增了多项核心权益。会员用户不仅可以畅享全平台高清内容，还将获得独家原创节目、院线新片优先观看权、以及限量线下观影活动邀请函。</p>
<h2>新增权益一览</h2>
<ul>
<li><strong>独家原创内容：</strong>每月推出会员专享原创节目，涵盖影视解读、幕后花絮、主创访谈等深度内容</li>
<li><strong>优先观影权：</strong>热门新片上线前48小时，会员可抢先观看</li>
<li><strong>多屏共享：</strong>一个会员账号支持最多4台设备同时在线</li>
<li><strong>线下活动：</strong>定期举办会员专属观影会、明星见面会等线下活动</li>
<li><strong>积分兑换：</strong>观影积分可兑换周边礼品、优惠券等福利</li>
</ul>
<h2>会员等级体系</h2>
<p>新版<strong>麻豆在线会员</strong>分为普通会员、黄金会员和钻石会员三个等级，不同等级享受差异化权益。黄金会员及以上可享4K超清画质和杜比音效，钻石会员更享有专属客服和定制化内容推荐服务。</p>`,
    category: 'huiyuan-zhuanxiang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20interior%20with%20golden%20accent%20details%2C%20premium%20membership%20card%20on%20marble%20surface%2C%20warm%20golden%20hour%20lighting%2C%20luxurious%20yet%20subtle%20atmosphere%2C%20soft%20neutral%20background%2C%20high-end%20lifestyle%20photography&width=800&height=500&seq=article-vip-upgrade&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20interior%20with%20golden%20accent%20details%2C%20premium%20membership%20card%20on%20marble%20surface%2C%20warm%20golden%20hour%20lighting%2C%20luxurious%20yet%20subtle%20atmosphere%2C%20soft%20neutral%20background%2C%20high-end%20lifestyle%20photography&width=300&height=300&seq=article-vip-upgrade-thumb&orientation=squarish',
    author: '麻豆在线编辑部',
    date: '2026-08-03',
    readTime: '6分钟',
    tags: ['麻豆在线', '会员升级', '会员权益', 'VIP'],
    featured: true,
  },
  {
    id: 3,
    slug: '2026-guochanyingshi-qushi',
    title: '2026年国产影视行业趋势分析：精品化与多元化并进',
    excerpt: '深度解析2026年国产影视行业发展方向，从内容创作、技术创新到市场格局，全面展现行业新趋势。',
    content: `<p>2026年，国产影视行业迎来新的发展机遇期。<strong>麻豆在线</strong>作为行业重要参与者，深度观察并积极参与这一变革浪潮。本文将从多个维度分析当前行业趋势。</p>
<h2>内容精品化成为主流</h2>
<p>随着观众审美水平的持续提升，粗制滥造的内容已无法获得市场认可。<strong>麻豆在线最新内容</strong>策略聚焦精品化路线，严格把控内容质量，从剧本筛选到后期制作均执行高标准。</p>
<h2>技术创新驱动体验升级</h2>
<p><strong>麻豆在线高清</strong>技术持续迭代，AI画质增强、智能推荐算法等创新技术的应用，正在重塑用户的观影方式。平台通过深度学习分析用户偏好，实现千人千面的个性化内容推荐。</p>
<h2>多元化内容生态</h2>
<p>短剧、互动影视、VR内容等新兴形态蓬勃发展。<strong>麻豆在线资源导航</strong>持续拓展内容边界，为用户提供更加丰富的选择空间。</p>`,
    category: 'hangye-dongtai',
    imageUrl: 'https://readdy.ai/api/search-image?query=Contemporary%20creative%20office%20space%20with%20film%20production%20storyboards%20on%20wall%2C%20warm%20industrial%20aesthetic%2C%20soft%20natural%20light%20streaming%20through%20large%20windows%2C%20modern%20minimalist%20design%2C%20cinematic%20color%20grading%2C%20professional%20atmosphere&width=800&height=500&seq=article-industry-trend&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Contemporary%20creative%20office%20space%20with%20film%20production%20storyboards%20on%20wall%2C%20warm%20industrial%20aesthetic%2C%20soft%20natural%20light%20streaming%20through%20large%20windows%2C%20modern%20minimalist%20design%2C%20cinematic%20color%20grading%2C%20professional%20atmosphere&width=300&height=300&seq=article-industry-trend-thumb&orientation=squarish',
    author: '麻豆在线研究院',
    date: '2026-07-28',
    readTime: '10分钟',
    tags: ['麻豆在线', '影视行业', '行业趋势', '2026'],
    featured: false,
  },
  {
    id: 4,
    slug: 'remen-bangdan-8yue-diyizhou',
    title: '麻豆在线热门排行：8月第一周最受欢迎内容TOP10',
    excerpt: '麻豆在线8月第一周热门内容排行榜出炉，多部新上线作品表现亮眼，来看看大家都在看什么。',
    content: `<p><strong>麻豆在线</strong>8月第一周热门内容排行榜正式发布。本周榜单竞争激烈，多部新上线作品强势入榜，经典内容表现依旧稳健。</p>
<h2>本周TOP10榜单</h2>
<ol>
<li><strong>《夏日狂想曲》</strong> - 青春励志题材，上线三天即登顶</li>
<li><strong>《迷雾追踪》</strong> - 悬疑推理剧集，口碑持续发酵</li>
<li><strong>《味蕾环游记》</strong> - 美食纪录片系列新作</li>
<li><strong>《星际迷航：新纪元》</strong> - 科幻大片</li>
<li><strong>《笑傲江湖之东方不败》</strong> - 经典武侠重制版</li>
<li><strong>《城市夜未央》</strong> - 都市情感剧</li>
<li><strong>《深海探秘》</strong> - 海洋纪录片</li>
<li><strong>《极限挑战2026》</strong> - 综艺节目</li>
<li><strong>《古墓奇谭》</strong> - 冒险动作片</li>
<li><strong>《我们的歌》</strong> - 音乐综艺</li>
</ol>
<p>本周<strong>麻豆在线最新内容</strong>中，青春励志与悬疑推理类型表现尤为突出，反映出用户对高质量剧情内容的强烈需求。</p>`,
    category: 'remen-paihang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20minimalist%20ranking%20board%20concept%20with%20warm%20ambient%20lighting%2C%20elegant%20numbered%20list%20display%2C%20modern%20interior%20setting%20with%20subtle%20textures%2C%20clean%20aesthetic%2C%20warm%20golden%20and%20cream%20color%20palette&width=800&height=500&seq=article-top10-aug&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Stylish%20minimalist%20ranking%20board%20concept%20with%20warm%20ambient%20lighting%2C%20elegant%20numbered%20list%20display%2C%20modern%20interior%20setting%20with%20subtle%20textures%2C%20clean%20aesthetic%2C%20warm%20golden%20and%20cream%20color%20palette&width=300&height=300&seq=article-top10-aug-thumb&orientation=squarish',
    author: '麻豆在线数据组',
    date: '2026-08-08',
    readTime: '5分钟',
    tags: ['麻豆在线', '热门排行', '排行榜', 'TOP10'],
    featured: true,
  },
  {
    id: 5,
    slug: 'madou-zaixian-app-xinbanben',
    title: '麻豆在线App全新版本发布，体验全面优化',
    excerpt: '麻豆在线移动端App迎来重大版本更新，界面焕新、性能提升、新增多项便捷功能。',
    content: `<p><strong>麻豆在线官方入口</strong>移动端App迎来重磅更新。全新3.0版本在界面设计、播放体验、交互逻辑等方面进行了全面优化，为用户带来更加流畅便捷的使用体验。</p>
<h2>全新界面设计</h2>
<p>新版本采用极简设计语言，优化信息层级，让<strong>麻豆在线资源导航</strong>更加清晰直观。首页智能推荐算法升级，内容发现效率提升40%。</p>
<h2>性能大幅提升</h2>
<p>播放器引擎全面重写，启动速度提升50%，<strong>麻豆在线高清</strong>播放缓冲时间缩短至毫秒级别。支持智能码率调节，弱网环境下也能流畅观影。</p>`,
    category: 'guanfang-gonggao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Sleek%20smartphone%20displaying%20modern%20video%20streaming%20app%20interface%20on%20screen%2C%20minimalist%20desk%20setup%20with%20warm%20lighting%2C%20clean%20white%20background%2C%20soft%20shadows%2C%20contemporary%20tech%20lifestyle%20photography&width=800&height=500&seq=article-app-update&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Sleek%20smartphone%20displaying%20modern%20video%20streaming%20app%20interface%20on%20screen%2C%20minimalist%20desk%20setup%20with%20warm%20lighting%2C%20clean%20white%20background%2C%20soft%20shadows%2C%20contemporary%20tech%20lifestyle%20photography&width=300&height=300&seq=article-app-update-thumb&orientation=squarish',
    author: '麻豆在线技术团队',
    date: '2026-08-01',
    readTime: '4分钟',
    tags: ['麻豆在线', 'App更新', '新版本', '移动端'],
    featured: false,
  },
  {
    id: 6,
    slug: 'jingxuan-jilupian-tuijian',
    title: '麻豆在线精选纪录片推荐：足不出户看世界',
    excerpt: '麻豆在线精选十部高分纪录片，涵盖自然、人文、科技、美食等主题，让你足不出户探索世界。',
    content: `<p><strong>麻豆在线</strong>纪录片板块持续扩充优质内容，本期为大家精选十部高分纪录片，涵盖自然风光、人文历史、科技创新、美食文化等多元主题。</p>
<h2>自然探索系列</h2>
<p><strong>麻豆在线高清</strong>画质完美呈现大自然的壮丽景观。从北极冰川到热带雨林，从深海奇观到高山秘境，每一帧都是视觉盛宴。</p>
<h2>人文历史系列</h2>
<p>深入了解世界各地的文化脉络与历史变迁，<strong>麻豆在线资源导航</strong>为用户精心挑选最具深度的人文纪录片。</p>`,
    category: 'yingshi-tuijian',
    imageUrl: 'https://readdy.ai/api/search-image?query=Serene%20minimalist%20living%20room%20with%20large%20screen%20showing%20nature%20documentary%20scene%2C%20warm%20cozy%20atmosphere%2C%20soft%20natural%20light%2C%20neutral%20earth%20tones%2C%20plants%20and%20wooden%20furniture%2C%20contemporary%20interior%20design&width=800&height=500&seq=article-documentary&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Serene%20minimalist%20living%20room%20with%20large%20screen%20showing%20nature%20documentary%20scene%2C%20warm%20cozy%20atmosphere%2C%20soft%20natural%20light%2C%20neutral%20earth%20tones%2C%20plants%20and%20wooden%20furniture%2C%20contemporary%20interior%20design&width=300&height=300&seq=article-documentary-thumb&orientation=squarish',
    author: '麻豆在线编辑部',
    date: '2026-07-25',
    readTime: '7分钟',
    tags: ['麻豆在线', '纪录片', '影视推荐', '精选'],
    featured: false,
  },
  {
    id: 7,
    slug: 'xinren-zhinan-kuaisu-shangshou',
    title: '麻豆在线新用户指南：快速上手全攻略',
    excerpt: '刚接触麻豆在线？这份详细的新手指南帮你快速了解平台功能，轻松开启高清观影之旅。',
    content: `<p>欢迎加入<strong>麻豆在线</strong>！作为新用户，你可能对平台的各项功能还不太熟悉。别担心，这份新手指南将帮你快速上手，尽享高清观影乐趣。</p>
<h2>注册与登录</h2>
<p>访问<strong>麻豆在线官方入口</strong>，使用手机号或邮箱即可快速注册。注册即享新用户专属福利，首次观影免费体验高清画质。</p>
<h2>内容发现</h2>
<p>通过<strong>麻豆在线资源导航</strong>，你可以按分类浏览、搜索关键词或查看热门排行来发现感兴趣的内容。智能推荐系统会根据你的观影偏好，持续推送个性化内容。</p>`,
    category: 'guanfang-gonggao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%20with%20laptop%20showing%20welcome%20screen%2C%20warm%20minimalist%20setting%2C%20soft%20natural%20lighting%2C%20cozy%20atmosphere%2C%20neutral%20cream%20and%20beige%20tones%2C%20lifestyle%20photography&width=800&height=500&seq=article-newbie-guide&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%20with%20laptop%20showing%20welcome%20screen%2C%20warm%20minimalist%20setting%2C%20soft%20natural%20lighting%2C%20cozy%20atmosphere%2C%20neutral%20cream%20and%20beige%20tones%2C%20lifestyle%20photography&width=300&height=300&seq=article-newbie-guide-thumb&orientation=squarish',
    author: '麻豆在线客服团队',
    date: '2026-07-20',
    readTime: '5分钟',
    tags: ['麻豆在线', '新手指南', '使用教程', '入门'],
    featured: false,
  },
  {
    id: 8,
    slug: 'hezuo-huoban-jihua',
    title: '麻豆在线内容合作伙伴计划正式启动',
    excerpt: '麻豆在线面向优秀内容创作者推出合作伙伴计划，提供流量扶持、收益分成等多项激励政策。',
    content: `<p><strong>麻豆在线</strong>正式启动内容合作伙伴计划，面向全国优秀内容创作者开放申请。该计划旨在构建开放共赢的内容生态，为创作者提供全方位的支持与激励。</p>
<h2>合作权益</h2>
<p>加入<strong>麻豆在线</strong>合作伙伴计划，创作者将获得首页推荐位、专属流量扶持、有竞争力的收益分成以及专业的内容运营指导。</p>
<h2>申请条件</h2>
<p>拥有原创正版内容、内容质量达到平台标准、具备持续创作能力的个人或机构均可申请。<strong>麻豆在线官方入口</strong>设有专门申请通道。</p>`,
    category: 'guanfang-gonggao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20collaborative%20workspace%20with%20creative%20team%20brainstorming%2C%20warm%20lighting%2C%20minimalist%20design%2C%20glass%20walls%2C%20plants%2C%20contemporary%20office%20aesthetic%2C%20soft%20neutral%20colors&width=800&height=500&seq=article-partner-plan&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Modern%20collaborative%20workspace%20with%20creative%20team%20brainstorming%2C%20warm%20lighting%2C%20minimalist%20design%2C%20glass%20walls%2C%20plants%2C%20contemporary%20office%20aesthetic%2C%20soft%20neutral%20colors&width=300&height=300&seq=article-partner-plan-thumb&orientation=squarish',
    author: '麻豆在线运营团队',
    date: '2026-07-15',
    readTime: '6分钟',
    tags: ['麻豆在线', '合作伙伴', '创作者', '内容生态'],
    featured: false,
  },
];

export const faqs = [
  {
    question: '麻豆在线是什么平台？',
    answer: '麻豆在线是一个官方正版高清影视内容平台，为用户提供海量优质影视资源，涵盖电影、电视剧、纪录片、综艺等多种内容类型。平台所有内容均获正版授权，支持高清流畅播放。',
  },
  {
    question: '如何注册麻豆在线会员？',
    answer: '您可以通过麻豆在线官方网站或App，使用手机号或邮箱快速注册成为会员。注册即享新用户专属福利，包括免费观影体验和会员优惠券。',
  },
  {
    question: '麻豆在线会员有哪些权益？',
    answer: '麻豆在线会员享有无广告观影、4K超清画质、杜比全景声、多设备同步观看、独家原创内容、优先观影权、线下活动参与等多项专属权益。会员分为普通、黄金和钻石三个等级，不同等级权益有所不同。',
  },
  {
    question: '麻豆在线支持哪些设备观看？',
    answer: '麻豆在线支持手机（iOS/Android）、平板、电脑网页端以及智能电视等多设备观看。一个会员账号支持最多4台设备同时在线，观影记录自动云端同步。',
  },
  {
    question: '如何联系麻豆在线客服？',
    answer: '您可以通过以下方式联系麻豆在线客服：在线客服（官网和App内均有入口）、客服邮箱（support@madouzx.com）、官方微信公众号（麻豆在线）。客服工作时间为每日9:00-21:00。',
  },
  {
    question: '麻豆在线的内容多久更新一次？',
    answer: '麻豆在线内容团队每日更新平台内容，每周推出新片推荐和热门榜单，每月发布月度内容计划。重大档期（如暑期档、春节档）会有大规模内容上新。',
  },
];

export const siteInfo = {
  name: '麻豆在线',
  tagline: '官方正版高清影视内容平台',
  description: '麻豆在线为用户提供高清正版影视内容，海量优质资源随时在线畅享。汇聚最新资讯、内容导航与会员服务，安全稳定，极速加载。',
  email: 'support@madouzx.com',
  wechat: '麻豆在线',
  phone: '400-888-8888',
  address: '北京市朝阳区光华路数字内容产业园',
  year: 2026,
};

export const aboutStats = [
  { label: '正版内容（部）', value: '50,000+' },
  { label: '活跃用户', value: '3,200万+' },
  { label: '合作版权方', value: '500+' },
  { label: '日均播放量', value: '8,000万+' },
];

export const aboutMilestones = [
  { year: '2018', title: '平台创立', description: '麻豆在线正式成立，致力于打造正版高清影视内容平台' },
  { year: '2019', title: '内容突破', description: '平台内容突破1万部，用户数突破500万' },
  { year: '2020', title: '技术升级', description: '全面支持4K超清画质，推出智能推荐系统' },
  { year: '2021', title: '会员体系', description: '上线会员体系，注册用户突破1000万' },
  { year: '2022', title: '生态拓展', description: '开启内容合作伙伴计划，构建开放内容生态' },
  { year: '2023', title: '行业领先', description: '活跃用户突破2000万，成为行业头部平台' },
  { year: '2024', title: '全球拓展', description: '内容覆盖多语种，服务延伸至海外华人市场' },
  { year: '2025', title: 'AI赋能', description: 'AI智能推荐与画质增强技术全面应用' },
  { year: '2026', title: '全新升级', description: '会员体系全面升级，推出钻石会员等级' },
];